import { Carousel } from '@fancyapps/ui';
import '@fancyapps/ui/dist/carousel/carousel.css';
//Logo carousel
export default class LogoCarousel {
    element;
    constructor(element) {
        this.element = element;
        this.init();
    }
    init() {
        new Carousel(this.element, {
            infinite: true,
            slidesPerPage: 1,
            Dots: false,
        });
    }
}
